import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../../constants/ActionNameConstants';
import { PROOFREADER_FILE_FILTER_API_URL } from '../../../../../constants/ApiUrlConstants';
import { getApiRequest } from '../../../../../features/axiosClient';
import { proofreaderFilesFilterFailure, proofreaderFilesFilterSuccess } from '../actions';

const filesFilterAPI = (action) =>
  getApiRequest(`${PROOFREADER_FILE_FILTER_API_URL}?UserId=${action?.UserId}&isMyFiles=${action?.isMyFiles}`);

function* handleFilesFilterAPI(action) {
  try {
    const response = yield call(filesFilterAPI, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(proofreaderFilesFilterSuccess(response));
  } catch (error) {
    yield put(proofreaderFilesFilterFailure(error));
  }
}

export function* watchProofreaderFilesFilterList() {
  yield takeLatest(types.GET_PROOFREADER_FILES_FILTER_LIST_REQUEST, handleFilesFilterAPI);
}
